module.exports = {
  name: {
    home: 'Trang Chủ',
    data: 'Dữ Liệu',
    permission: 'Phân Quyền',
    member: 'Thành Viên',
    agent: 'Agent',
    setting: 'Cài Đặt',
    login: 'Đăng Nhập',
    logout: 'Đăng Xuất',
    country: 'Quốc Gia',
    phone: 'Số ĐT',
    account: 'Tài Khoản',
    sms_code: 'Mã SMS',
    password: 'Mật Khẩu',
    to: 'Đến',
    all: 'Tất cả',
    source: 'Nguồn',
    target: 'Định cức',
    success: 'Thành công',
    succeed: 'Đã thành công',
    failed: 'không thành công',
    error: 'Lỗi',
    'status': 'Trạng thái',
    detail: 'chi tiết',
    add: 'Thêm',
    added: 'Đã thêm',
    name: 'Tên',
    type: 'Loại',
    method: 'Phương pháp',
    cancel: 'Hủy bỏ',
    canceled: 'Đã hủy bỏ',
    ok: 'OK',
    run: 'Chạy',
    running: 'Đang chạy',
    action: 'Hoạt động',
    actions: 'Hành động',
    delete: 'Xóa',
    deleted: 'Đã xóa',
    hit: 'Bắn',
    rename: 'Sửa tên',
    save: 'Lưu',
    config: 'Cấu hình',
    schedule: 'Lịch trình',
    transaction: 'Giao dịch',
    history: 'Lịch sử',
    generate: 'phát sinh',
    address: 'Địa chỉ',
    edit: 'Sửa',
    copy: 'Sao chép',
    paste: 'Dán',
    field: 'lọc',
    writeback: 'Viết lại',
    digit: 'Chữ số',
    start: 'Bắt đầu',
    end: 'Kết thúc',
    rule: 'Qui định',
    minute: 'Phút',
    hour: 'Giờ',
    day: 'Ngày',
    week: 'Tuần',
    month: 'Tháng',
    monday: 'Thứ hai',
    tuesday: 'Thứ ba',
    wednesday: 'Thứ tư',
    thursday: 'Thứ năm',
    friday: 'Thứ sáu',
    saturday: 'Thứ bảy',
    sunday: 'Chủ nhật',
    value: 'Giá trị',
    team: 'Nhóm',
    log: 'Nhật ký',
    search: 'Tìm kiếm',
    query: 'Truy vấn',
    reset: 'Cài lại',
    variable: 'Biến số',
    profile: 'Hồ sơ',
    username: 'Tên người dùng',
    nickname: 'Biệt danh ',
    bind: 'Liên kết',
    unbind: 'Ngăt kiên kết',
    change: 'Thay đổi',
    code: 'Code',
    authorization: 'Ủy quyền',
  },
  message: {
    please_enter: 'Vui lòng thử lại',
    please_choice: 'Vui lòng chọn',
    please_enter_something: 'Vui lòng nhập {msg}',
    get_code: 'Lấy mã',
    get_sms_code: 'Lấy mã SMS',
    try_again: 'Hãy thử lại',
    date_start: 'Ngày bắt đầu',
    date_end: 'Ngày kết thúc',
    finished_at: 'Đã hoàn thành lúc',
    data_status: 'Trạng thái dữ liệu',
    recent_transfer: 'Giao dịch gần đây',
    latest_week: 'Tuần trước',
    latest_month: 'Tháng trước',
    last_three_months: '3 tháng trước',
    latest_transfer_time: 'Thời gian giao dịch lần trước',
    delete_confirm: 'Hành động này sẽ xóa dữ liệu, bạn có chắc chắn tiếp tục?',
    something_invalid: '{msg} không hợp lệ',
    something_required: '{msg} bắt buộc!',
    something_succeed: '{msg} đã thành công!',
    something_failed: '{msg} đã không thành công!',
    operation_succeed: 'Hoạt động đã thành công!',
    operation_failed: 'Hoạt động đã không thành công!',
    running_succeed: 'Chạy thành công!',
    running_failed: 'Chay không thành công!',
    data_format: 'Định dạng dữ liệu',
    string_list: 'Danh sách chuỗi',
    paste_formated_json: 'Dán vào định dạng của Json',
    copy_succeed: 'Sao chép thành công!',
    copy_failed: 'sao chép không thành công!',
    new_node: 'Lưu ý mới',
    api_request_failed: 'Yêu cầu dữ liệu không thành công!',
    schedule_hour: '{minute} Phút/Giờ',
    schedule_day: '{hour}:{minute} /Ngày',
    schedule_week: '{hour}:{minute} /Thứ {weekday}',
    schedule_month: '{hour}:{minute} / Ngày {day_of_month}',
    please_choice_target_data: 'Vui lòng chọn 1 định mức dữ liệu',
    reset_agent_key_hit: 'Sau khi đặt lại khóa cũ sẽ không hợp lệ, bạn có chắc chắn tiếp tục không?',
    env_variable: 'Biến Env',
    add_team: 'Tạo nhóm mới',
    change_to_team: 'Thay đổi sang nhóm {msg}',
    something_alert: '{msg} Thông báo',
    change_something: 'Thay đổi {msg}',
    phone_source: 'Số điện thoại gốc',
    phone_new: 'Số điện thoại mới',
    phone_no_bind: 'Vui lòng liên kết điện thoại trước!',
    password_new: 'Mật khẩu mới',
    password_confirm: 'Xác nhận mật khẩu',
    password_inconsistent: 'Mật khẩu mới và mật khẩu xác nhận không giống nhau',
    password_invalid: 'Mật khẩu không hợp lệ, độ dài yêu cầu từ {min} đến {max}',
  }
}



// WEBPACK FOOTER //
// ./src/lang/vi.js